import { useSocket } from "./useSocket";

export function useSocketEmit() {
  const { socket } = useSocket();

  const emit = <T>(event: string, data: T) => {
    if (!socket) {
      console.warn(`Socket bağlı değil. Emit yapılmadı: ${event}`);
      return;
    }

    socket.emit(event, data);
  };

  return { emit };
}
